import React from 'react';
import './SettingsTab.scss';
import AccountDataForm from './AccountDataForm';
import NewsletterSection from './NewsletterSection';
import ChangePasswordModal from './ChangePasswordModal';
import RemoveWebUserAction from './RemoveWebUserAction';
import EADivider from '../../../shared/EADivider';

const SettingsTab: React.FC = () => {
  return (
    <div className="tab-content__container">
      <AccountDataForm />
      <EADivider />
      <NewsletterSection />
      <ChangePasswordModal />
      <EADivider />
      <RemoveWebUserAction />
    </div>
  );
};

export default SettingsTab;
